import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { UserNameDisplayResultDto } from '../../../../../_models/user-name-display-result-dto';
import { DimensionSelectorResultDto } from '../../common/dimensions/dimension-selector-result-dto';
import { GLAccountSelectorResultDto } from '../../common/gl-account/glaccount-selector-result-dto';
import { ARAdjustmentRawDto } from './ar-adjustment-raw-dto';

export class ARAdjustmentEditorResultDto {
    @Type(() => KeyValueResultDto)
    adjustmentTypes: KeyValueResultDto[];

    @Type(() => KeyValueResultDto)
    subLedgers: KeyValueResultDto[];

    @Type(() => GLAccountSelectorResultDto)
    glAccounts: GLAccountSelectorResultDto[];

    @Type(() => DimensionSelectorResultDto)
    glDimensions: DimensionSelectorResultDto[];

    @Type(() => UserNameDisplayResultDto)
    updatedBy: UserNameDisplayResultDto;

    @Type(() => ARAdjustmentRawDto)
    adjustmentInfo: ARAdjustmentRawDto;

    @Type(() => Date)
    closedBookPeriodDate: Date;

    entityUsesSubCategory: boolean;

    charge: number;
    chargeDue: number;

    /**
     * This property is used only in edit mode. if true - all the allowed fields are editable.
     * If false the user can assume that AllowBasicEdit mode is true, otherwise exception would have been thrown already
     * Editable Fields "Adjustment Type", "Description", "Document Date", "Post Date","Sub Ledger", Line Items, New Line Item, Delete LineItem
     */
    allowFullEdit: boolean;

    /**
     * This property is used only in edit mode.  true - allow other dimension for edit
     * This property is not depndent on the AllowFullEdit property. ie it is always editable if AllowOtherDimensionEdit is true
     */
    allowOtherDimensionEdit: boolean;

    customerName: string;
    defaultCROffsetGLAccountNumber: string;
    defaultDROffsetGLAccountNumber: string;
    allowCreditApplications: boolean;
}
